const input_pt={
    "requiredErrorMessage":"Campo obrigatório",
    "validationErrorMessage":"Dado inválido"
}  
export default input_pt;